enum ExportPeriod {
  CurrentMonthInMsk = 'currentMonthInMsk',
  LastMonthInMsk = 'lastMonthInMsk',
  LastThreeMonthsInMsk = 'lastThreeMonthsInMsk'
}

const { CurrentMonthInMsk, LastMonthInMsk, LastThreeMonthsInMsk } = ExportPeriod

const filenamePostfixMapping = new Map([
  [CurrentMonthInMsk, 'за текущий месяц'],
  [LastMonthInMsk, 'за прошлый месяц'],
  [LastThreeMonthsInMsk, 'за последние 3 месяца']
])

const nameMapping = new Map([
  [CurrentMonthInMsk, 'Текущий месяц'],
  [LastMonthInMsk, 'Прошлый месяц'],
  [LastThreeMonthsInMsk, 'Последние 3 месяца']
])

namespace ExportPeriod {
  export const sortedMembers = [CurrentMonthInMsk, LastMonthInMsk, LastThreeMonthsInMsk]

  export function getFilenamePostfix (exportPeriod: ExportPeriod): string {
    return filenamePostfixMapping.get(exportPeriod)!
  }

  export function getName (exportPeriod: ExportPeriod): string {
    return nameMapping.get(exportPeriod)!
  }
}

export default ExportPeriod
